import {Component, inject}                       from '@angular/core';
import {FormsModule}                             from '@angular/forms';
import {MindConfIntf, MindRecordLogIntf}         from '@djsharkk/logr-types';
import {v4 as uuidv4}                            from 'uuid';
import {AuthUnlockService}                       from '../../../../../../../logr-auth/utils/auth-unlock.service';
import {MenuCrudPanelContentBase}                from '../../menu-crud-panel-content-base';
import {MenuCrudPanelMindService}                from '../../menu-crud-panel-top/menu-crud-panel-mind-top/menu-crud-panel-mind.service';
import {MenuCrudPanelBotComponent, PanelBtnIntf} from '../menu-crud-panel-bot.component';

@Component({
			   selector   : 'app-menu-crud-panel-psyc-mind',
			   imports    : [
				   MenuCrudPanelBotComponent,
				   FormsModule
			   ],
			   templateUrl: './menu-crud-panel-mind-bot.component.html',
			   styleUrl   : './menu-crud-panel-mind-bot.component.css'
		   })
export class MenuCrudPanelMindBotComponent extends MenuCrudPanelContentBase<MindRecordLogIntf, MindConfIntf> {
	svcAuthUnlock = inject(AuthUnlockService)

	svcMenuCrudMind = inject(MenuCrudPanelMindService)

	btnsL: PanelBtnIntf[] = [
		{
			text: 'Add',
			icon: 'plus',
			func: async () => {
				await this.svcMenuCrudMind.addRecord();
				this.svcMenuCrudMind.selected = [];
				this.svcMenuCrudMind.note = '';
			},
			uuid: uuidv4()
		}

	]

	constructor() {
		super('mind', true);
	}
}
